import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_hint_shortcut } from '@/hooks/hints_shortcut/use_hint_shortcut';
import { use_slice_generation, use_slice_ml_asset, use_slice_ui } from '@/hooks/store/use_slices';
import { use_generation_current_price } from '@/hooks/use_generation_current_price';
import { REMOTE__generation_start } from '@/state/generation/status/REMOTE__generation_start';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { DTO_REQUEST__generation_start } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_start';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useMemo } from 'react';
import { HOOK_GENERATION__notifier } from './HOOK_GENERATION__notifier';

export function HOOK_GENERATION__start() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { notifier } = HOOK_GENERATION__notifier(ENUM__component_type.PAGE_GENERATION_BUTTON_GENERATION_START);

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current, generation_ids_with_locked_status } = use_slice_generation(['generation_current', 'generation_ids_with_locked_status']);

  const { reservations_map_all } = use_slice_ml_asset(['reservations_map_all']);

  /*
   * STATE
   */

  const { on_user_uses_shortcut, on_user_uses_component } = use_hint_shortcut(EShortcutType.GENERATION_START);

  const { generation_current_price } = use_generation_current_price(true);

  const can_start_generation = useMemo(
    () => get_can_start_generation(),
    [generation_current.status, generation_ids_with_locked_status, generation_current_price, g_general__ui_disabled],
  );

  /*
   * METHODS
   */
  async function generation_start(is_used_shortcut: boolean) {
    if (!can_start_generation) return;

    generation_current.assert_statuses(CONSTANTS__shared.ALLOWED_STATUSES_TO_GENERATION_START);

    let reseration = Array.from(reservations_map_all.values())[0]; //todo:remove

    let request = new DTO_REQUEST__generation_start();
    request.generation_id = generation_current._id;
    request.ml_asset_reservation_id = ENUM__string_id_empty.OBJECT_ID; //todo: use reservation id

    await dispatch(REMOTE__generation_start(request));

    await notifier.send_action();

    is_used_shortcut ? on_user_uses_shortcut() : on_user_uses_component();
  }

  function get_can_start_generation() {
    if (isNaN(generation_current_price)) return false; //determining price
    if (!CONSTANTS__shared.ALLOWED_STATUSES_TO_GENERATION_START.includes(generation_current.status)) return false;
    if (generation_ids_with_locked_status.has(generation_current._id)) return false;
    if (g_general__ui_disabled) return false;

    return true;
  }

  /*
   * RESULT
   */
  return { generation_start, can_start_generation };
}
